import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-license-quantity-input',
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    TranslocoPipe,
    MatTooltip,
  ],
  templateUrl: './license-quantity-input.component.html',
  styleUrl: './license-quantity-input.component.css',
})
export class LicenseQuantityInputComponent {
  @Input() quantity: number | null;
  @Input() disabled = false;
  @Input() min: number;
  @Input() max: number;
  @Input() pattern = /^[0-9]+$/;
  @Input() defaultValue = 1;
  @Output() quantityChanged: EventEmitter<number> = new EventEmitter<number>();

  onDecrease(): void {
    this.quantity ??= this.min;
    if (this.quantity > this.min) {
      this.quantity = this.quantity - 1;
      this.quantityChanged.emit(this.quantity);
    }
  }

  onIncrease(): void {
    this.quantity ??= this.min;
    if (this.quantity < this.max) {
      this.quantity = this.quantity + 1;
      this.quantityChanged.emit(this.quantity);
    }
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = parseInt(input.value, 10);
    const validNumber = this.pattern.test(input.value);
    if (isNaN(value) || !validNumber) {
      input.value = (this.quantity ?? this.defaultValue).toString();
      return;
    }
    if (value < this.min) {
      value = this.min;
      input.value = value.toString();
    }
    if (value > this.max) {
      value = this.max;
      input.value = value.toString();
    }
    this.quantity = value;
    this.quantityChanged.emit(value);
  }
}
